<template>
  <el-form class="search_form" :model="searchForm" ref="searchForm" size="mini" :inline="true">
    <el-col :span="3">
      <el-form-item prop="operatorId">
        <el-cascader  size="mini" clearable  ref="cascader"
                      :placeholder="$t('deviceControl.operatorId')" filterable
                      :options="operatorTree"
                      :props="{checkStrictly:true,expandTrigger:'hover'}"
                      :show-all-levels="false"
                      change-on-select
                      @change='handleChangeOperator'
                      v-model="searchForm.operatorId">
        </el-cascader>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="name">
        <el-input :placeholder="$t('xiang-bian-ming-cheng')" v-model="searchForm.name"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="stationName">
        <el-input :placeholder="$t('chang-zhan-ming-cheng')" v-model="searchForm.stationName"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="1.5">
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">{{ $t('deviceControl.empty') }}</el-button>
      </el-form-item>
    </el-col>
    <el-col :span="1.5">
      <el-form-item>
        <el-button  type="primary" icon="el-icon-search" @click="submitSearchForm"
                    :loading="searchLoading">{{ $t('deviceControl.search') }}
        </el-button>
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>

  import {validateInput} from '../../../../common/validator'

  export default {
    name: "search",
    data(){
      return{
      }
    },
    props:{
      searchForm:{},
      stationsForSelect: '',
      operatorForSelect: '',
      operatorTree:{
        type: Array,
        required: true
      },
      searchLoading: false,
    },
    methods:{
      resetSearchForm() {
        for(let item in this.searchForm) {
          if(this.searchForm[item]){
            this.searchForm[item] = ''
          }
        }
        this.submitSearchForm()
      },
      submitSearchForm(){
        this.$emit("submitSearchForm")
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.searchForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/gunBox/search.vue